exports.dataArr =[
  {
    sl_No: 1,
    public:false,
    Hospital_Names: "Babe Ke Hospital And IMT (Private), \nPlot No.6, Phase 3 A, Sector 53, Chandigarh, 160059",
    Lat: 30.7288808458698,
    Lng: 76.7313794127263
  },
  {
    sl_No: 2,
    public:true,
    Hospital_Names: "APC PGIMER Chandigarh (Public), \nShop No.2, Madhya Marg, near Punjab University, Sector 12, Chandigarh, 160012",
    Lat: 30.7681236062873,
    Lng: 76.7756680447703
  },
  {
    sl_No: 3,
    public:false,
    Hospital_Names: "Omni Hospital (Private), \nSco 343-345 Infront of Gurutegh Bahadur Gurudwara, Sector 34A, Chandigarh, 160022",
    Lat: 30.7251917946096,
    Lng: 76.7650250401706
  },
  {
    sl_No: 4,
    public:false,
    Hospital_Names: "Jindal hospital (Private), \n3052, Dakshin Marg, Sector 20D, Sector 20, Chandigarh, 160020",
    Lat: 30.7234209998578,
    Lng: 76.7753247220413
  },
  {
    sl_No: 5,
    public:false,
    Hospital_Names: "Mayo Hospital (Private), \nMQH4+HQH, Jagatpura, Chandigarh, Punjab 140306",
    Lat: 30.6828313753147,
    Lng: 76.7578152628611
  },
  {
    sl_No: 6,
    public:false,
    Hospital_Names: "Dr. Nagpal's Elite Clinic (Private), \n#5, A, Sector 19, Chandigarh, 160019",
    Lat: 30.7319795398188,
    Lng: 76.7923191971279
  },
  {
    sl_No: 7,
    public:true,
    Hospital_Names: "ESIC Model Hospital (Public), \nIndustrial Area Phase, 2, Ram Darbar, Chandigarh, 160002",
    Lat: 30.7006929137655,
    Lng: 76.7878560016506
  },
  {
    sl_No: 8,
    public:true,
    Hospital_Names: "Hospital (Public), \n24B, Sector 24, Chandigarh, 160036",
    Lat: 30.7489468113109,
    Lng: 76.7605618446933
  },
  {
    sl_No: 9,
    public:false,
    Hospital_Names: "German Hospital (Private), \nKaroran Rd, Govind Nagar, Nayagaon, Punjab 160103",
    Lat: 30.782143527233,
    Lng: 76.7983091653723
  },
  {
    sl_No: 10,
    public:false,
    Hospital_Names: "KSI Medicare Pvt. Ltd. (Private), \n2nd Floor, Sector 20D, Sector 20, Chandigarh, 160022",
    Lat: 30.7244624977851,
    Lng: 76.7753065425278
  },
  {
    sl_No: 11,
    public:false,
    Hospital_Names: "The Bliss Hospital (Private), \nThe Bliss Hospital, Sector 20, Panchkula, Haryana 134117",
    Lat: 30.6658840076663,
    Lng: 76.8571515267369
  },
  {
    sl_No: 12,
    public:false,
    Hospital_Names: "Shivalik Hospital (Private), \nce Heart & Vascular Institute, Japjee Dental Rd, opposite Shemrock School, Sector 69, Sahibzada Ajit Singh Nagar, Punjab 160062",
    Lat: 30.7002899480015,
    Lng: 76.7205561881014
  },
  {
    sl_No: 13,
    public:false,
    Hospital_Names: "Grecian Hospital (Private), \nJail Rd, Phase 9, Sahibzada Ajit Singh Nagar, Punjab 160062",
    Lat: 30.6954189267776,
    Lng: 76.722101140382
  },
  {
    sl_No: 14,
    public:false,
    Hospital_Names: "City Clinic (Private), \n130, Sector 56, Chandigarh, 160055",
    Lat: 30.7426427018038,
    Lng: 76.7159213312596
  },
  {
    sl_No: 15,
    public:false,
    Hospital_Names: "City Hospital (Private), \nSCO 10, 11, Madhya Marg, Sector 8C, Sector 9, Chandigarh, 160009",
    Lat: 30.7501589384786,
    Lng: 76.6463690267369
  },
  {
    sl_No: 16,
    public:false,
    Hospital_Names: "Eye Hospital (Private), \nPQMP+7RR, Sector 18-C, Sector 18, Chandigarh, 160018",
    Lat: 30.7380207393754,
    Lng: 76.7870289949239
  },
  {
    sl_No: 17,
    public:false,
    Hospital_Names: "Kare partner heart centre (Private), \n3314, 19D, Sector 19, Chandigarh, 160019",
    Lat: 30.7331516236842,
    Lng: 76.7894322540271
  },
  {
    sl_No: 18,
    public:true,
    Hospital_Names: "Advanced Trauma Centre (Public), \nPGI HOSPITAL CHANDIGARH, POST GRADUATE INSTITUTE OF MEDICAL EDUCATION & RESEARCH, Madhya Marg, Sector 12, Chandigarh, 160012",
    Lat: 30.7642802108223,
    Lng: 76.7755276835016
  },
  {
    sl_No: 19,
    public:false,
    Hospital_Names: "Eco City Apollo Hospital (Private), \nRP3R+44F, Unnamed Road, Eco City 1, New Chandigarh, Punjab 140901",
    Lat: 30.8077465116837,
    Lng: 76.7403119949239
  },
  {
    sl_No: 20,
    public:false,
    Hospital_Names: "Fortis Hospital Mohali (Private), \nJail Rd, Sector 62, Sahibzada Ajit Singh Nagar, Punjab 160062",
    Lat: 30.6991869358752,
    Lng: 76.7301501267369
  },
  {
    sl_No: 21,
    public:false,
    Hospital_Names: "Fortis Medcentre Hospital in Chandigarh (Private), \nSCO, 11D, Sector 11, Chandigarh, 160011",
    Lat: 30.7647129548795,
    Lng: 76.7818670335594
  },
  {
    sl_No: 22,
    public:false,
    Hospital_Names: "Harmony Hospital (Private), \nShahi Majra, Shop No. 97, Balongi Rd, near JD Hotel, Phase 5, Sector 58, Sahibzada Ajit Singh Nagar, Punjab 160055",
    Lat: 30.7229780430823,
    Lng: 76.7048426881013
  },
  {
    sl_No: 23,
    public:false,
    Hospital_Names: "ARV Orthopedic Hospital (Private), \n2125, Sector 21C, Sector 21, Chandigarh, 160021",
    Lat: 30.7275525506872,
    Lng: 76.7731639111771
  },
  {
    sl_No: 24,
    public:true,
    Hospital_Names: "DOTS Centre Civil Hospital Burail (Public), \n2056/2, Sukhna Path, Burail, Sector 45C, Sector 45, Chandigarh, 160047",
    Lat: 30.7099911614557,
    Lng: 76.7590876792871
  },
  {
    sl_No: 25,
    public:false,
    Hospital_Names: "Sarhind Orthopaedic Multispeciality Medical Centre (Private), \nSCO No. 23, Sector, 33D, Sector 33, Chandigarh, 160047",
    Lat: 30.7172227090685,
    Lng: 76.7676707475127
  },
  {
    sl_No: 26,
    public:false,
    Hospital_Names: "Apollo Clinic (Private), \nSCO 10, 11, Madhya Marg, Sector 8C, Sector 8, Chandigarh, 160009",
    Lat: 30.7437169703532,
    Lng: 76.7911494653723
  },
  {
    sl_No: 27,
    public:false,
    Hospital_Names: "Chd City Hospital (Private), \nSCO 10, 11, Madhya Marg, Sector 8C, Sector 9, Chandigarh, 160009",
    Lat: 30.7230596449426,
    Lng: 76.808830585917
  },
  {
    sl_No: 28,
    public:false,
    Hospital_Names: "Jindal IVF and Sant Memorial Nursing Home (Private), \n3050, Dakshin Marg, behind Sri Guru Ravidass Bhawan, Sector 20D, Sector 20, Chandigarh, 160020",
    Lat: 30.7221742320506,
    Lng: 76.7751849584727
  },
  {
    sl_No: 29,
    public:false,
    Hospital_Names: "Shalby Hospital Mohali (Private), \nPhase 9, Chandigarh, Punjab 160062",
    Lat: 30.6967889387064,
    Lng: 76.7327846014383
  },
  {
    sl_No: 30,
    public:true,
    Hospital_Names: "Civil Hospital Sector 22 (Public), \nSector 22 Market Rd, Sector 22D, Sector 22, Chandigarh, 160022",
    Lat: 30.736339862464,
    Lng: 76.7705501016309
  },
  {
    sl_No: 31,
    public:false,
    Hospital_Names: "Tera Hi Tera Mission Hospital (Private), \nSco 138, opposite E Sampark Center, Sector 45C, Sector 45, Chandigarh",
    Lat: 30.7091872421676,
    Lng: 76.757160515199
  },
  {
    sl_No: 32,
    public:true,
    Hospital_Names: "Government Multi Specialty Hospital (Public), \nMadhya Marg, Sector 16 A, Sector 16, Chandigarh, 160015",
    Lat: 30.7553716493871,
    Lng: 76.7808497835016
  },
  {
    sl_No: 33,
    public:false,
    Hospital_Names: "Magnum multi-speciality Hospital (Private), \nHouse No 2103 Near Congress Bhavan, 35C, Chandigarh, 160036",
    Lat: 30.7283719515279,
    Lng: 76.7602504197602
  },
  {
    sl_No: 34,
    public:true,
    Hospital_Names: "Hospital (Public), \nPQMC+RX8, Sector 22A, Sector 22, Chandigarh, 160062",
    Lat: 30.7388481425243,
    Lng: 76.7702067789019
  },
  {
    sl_No: 35,
    public:false,
    Hospital_Names: "Amcare Hospital (Private), \nVIP Road, Adjacent to Amcare Plaza, Zirakpur, Punjab 140603",
    Lat: 30.6419431433844,
    Lng: 76.8156310426433
  },
  {
    sl_No: 36,
    public:true,
    Hospital_Names: "Police hospital (Public), \n80, Purv Marg, Police Colony, Sector 26 East, Chandigarh, 160101",
    Lat: 30.7261903697567,
    Lng: 76.8114979267369
  },
  {
    sl_No: 37,
    public:false,
    Hospital_Names: "Nins Brain & Spine Hospital (Private), \nSCO 341-342, Sub. City Center, Sector 34A, Sector 34, Chandigarh, 160022",
    Lat: 30.7254525502059,
    Lng: 76.7651493583187
  },
  {
    sl_No: 38,
    public:false,
    Hospital_Names: "Ivy Hospital (Private), \nWard No. 6, 144501, Chandigarh Rd, Sector 47 D, Sector 47, Chandigarh, 160047",
    Lat: 30.6963779662626,
    Lng: 76.7636044060381
  },
  {
    sl_No: 39,
    public:true,
    Hospital_Names: "Civil Hospital (Public), \nPR7R+3XR, Sector 13, Chandigarh, 160101",
    Lat: 30.7186643453847,
    Lng: 76.8415386655264
  },
  {
    sl_No: 40,
    public:false,
    Hospital_Names: "Grecian Super Specialty Hospital (Private), \n Jail Rd, Phase 9, Sahibzada Ajit Singh Nagar, Punjab 160062",
    Lat: 30.6955609994713,
    Lng: 76.7219543653724
  }
]